import { render, staticRenderFns } from "./accidentAtWork.vue?vue&type=template&id=7c5e838c"
import script from "./accidentAtWork.vue?vue&type=script&lang=js"
export * from "./accidentAtWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports